import { Flex, theme } from 'antd';
import dayjs from 'dayjs';
import { type ReactNode, useEffect, useState } from 'react';
import DatePicker from '../../../../components/controls/date-picker';
import FilterSelect from '../../../../components/controls/filter-select';
import { type Customer } from '../../../../entities';
import { type IResult } from '../../../../jsonapi-provider';
import { LocalDate } from '../../../../utils/local-date';

export interface ScheduledMealFiltersProps {
  onChange?: (filters: FiltersState) => void;
  initialFilters?: FiltersState;
  showDate: boolean;
  customers: IResult<Customer[]>;
}

interface FiltersState {
  orderDate?: LocalDate;
  site?: string;
  customer?: string;
}

const ScheduledMealFilter = (props: ScheduledMealFiltersProps): ReactNode => {
  const { initialFilters, onChange, showDate = true, customers } = props;
  const [filters, setFilter] = useState<FiltersState>(initialFilters ?? {});
  const { token } = theme.useToken();

  useEffect(() => {
    onChange?.(filters);
  }, [filters]);

  return (
    <Flex gap={token.paddingXS} style={{ marginBottom: 20 }} flex={1} wrap="wrap">
      {showDate && (
        <DatePicker
          value={filters.orderDate && dayjs(filters.orderDate.toString())}
          title="Order Date"
          onChange={(value) => {
            setFilter((prev) => ({
              ...prev,
              orderDate: new LocalDate(value),
            }));
          }}
        />
      )}

      <FilterSelect
        value={filters?.customer}
        mode="single"
        options={customers.data?.map((cust) => ({ label: cust.name, value: cust.id })) ?? []}
        title="Customer"
        selectFirstOptionOnMount={false}
        onChange={(value) => {
          setFilter((prev) => ({
            ...prev,
            customer: value,
            site: undefined,
          }));
        }}
      />
      <FilterSelect
        value={filters?.site}
        mode="single"
        selectFirstOptionOnMount={false}
        options={
          customers.data
            ?.find((cust) => cust.id === filters.customer)
            ?.sites.map((site) => ({ label: site.name, value: site.id })) ?? []
        }
        title="Site"
        onChange={(value) => {
          setFilter((prev) => ({
            ...prev,
            site: value,
          }));
        }}
      />
    </Flex>
  );
};

ScheduledMealFilter.defaultProps = {
  onChange: () => {},
  initialFilters: {},
  customers: [],
};

export default ScheduledMealFilter;
